import { useState } from 'react';
import RegisterLink from '@/components/ui/RegisterLink';

// Exact FAQs from bybid9.com
const FAQS = [
  {
    q: 'What is the minimum deposit at Bybid9?',
    a: 'The minimum deposit at Bybid9 is AUD 10. This applies to all payment methods including PayID, OSKO, Google Pay, Apple Pay, Visa, Mastercard, Amopay, SpeedPay, and more. Our bank account for deposit are always changing. Always make sure to check the available bank account before depositing.'
  },
  {
    q: 'What is the minimum withdrawal amount at Bybid9?',
    a: 'The minimum withdrawal amount at Bybid9 is AUD 30. Withdrawals are processed quickly for verified accounts. Always make sure to check the available bank account before depositing as our bank account for deposit are always changing.'
  },
  {
    q: 'How does the 100% Slot Welcome Bonus work?',
    a: 'New members receive a 100% Slot Welcome Bonus on their first deposit with a minimum of AUD 10. This means if you deposit AUD 10, you get AUD 10 bonus to play slots at Bybid9. You can also join the exclusive monthly deposit ranking (up to AUD 3,999) and Daily Easy Step AUD 100 promotions on site.'
  },
  {
    q: 'How does the Bybid9 Referral Program work?',
    a: 'Share your unique Bybid9 referral link with friends. Every 1 share = FREE AUD $3. You also earn 0.9% daily rebate and 6% weekly commission on your downline activity. Use the Share, Downline, Copy, and More Info buttons in your account.'
  },
  {
    q: 'What is the Bybid9 Monthly Deposit Ranking?',
    a: 'Bybid9 runs an exclusive monthly competition deposit ranking. Top depositors compete for massive prizes and recognition on the Bybid9 leaderboard. Check the promotion page every time you login for the latest competition details. Perhaps a jackpot surprise is waiting for you!!'
  },
  {
    q: 'Is Bybid9 licensed and safe?',
    a: 'Yes. Bybid9 is officially licensed by PAGCOR (Philippine Amusement and Gaming Corporation) and certified by BMM Testlabs, eCOGRA, and TST. All transactions are protected by 256 bit SSL encryption and ThreatMetrix fraud prevention.'
  },
  {
    q: 'What games are available at Bybid9?',
    a: 'Bybid9 offers 5000+ real money games including pokies/slots, live dealer tables, fishing games, arcade games, and sports betting from 8 top providers including BNG, JILI, VPOWER, MEGA888, JOKER, PEGASUS, WF GAMING, and CQ9 GAMING.'
  },
  {
    q: 'How do I download the Bybid9 AUS App?',
    a: 'Visit https://www.bybid9h5api.xyz/uploads/appwrap.html to download the Bybid9 AUS App. Get into the app for best play. The app is available for both Android and iOS devices.'
  },
  {
    q: 'What payment methods does Bybid9 support?',
    a: 'Bybid9 supports PayID, OSKO, Google Pay, Apple Pay, Visa, Mastercard, Amopay, and SpeedPay. Amopay supports cryptocurrency deposits and withdrawals. All deposits are instant and all withdrawals are fast. Bybid9 never charges fees on deposits or withdrawals. Our bank account for deposit are always changing. Always check before depositing.'
  },
];

const SECURITY_CERTS = [
  { title: 'PAGCOR', sub: 'Licensed Operator' },
  { title: 'iTech Labs', sub: 'RNG Certified' },
  { title: 'BMM Testlabs', sub: 'Game Audited' },
  { title: 'ThreatMetrix', sub: 'Fraud Prevention' },
  { title: 'eCOGRA', sub: 'Player Protection' },
  { title: 'TST', sub: 'Technical Testing' },
  { title: '256 bit SSL', sub: 'Data Encryption' },
  { title: 'TrustPilot', sub: 'Verified Reviews' },
];

const WHY_FEATURES = [
  { icon: 'ri-flag-line', title: 'Optimised for Australia', desc: 'Built around Australian online pokies players. Trending slots, high RTP pokies, and game categories aligned with local demand. AUD currency supported. Min deposit AUD 10.' },
  { icon: 'ri-shield-check-line', title: 'RNG Certified Fair Play', desc: 'All titles operate using certified RNG systems to maintain consistent fairness, game integrity, and transparent results at Bybid9. Certified by BMM Testlabs and eCOGRA.' },
  { icon: 'ri-layout-grid-line', title: '5000+ Real Money Games', desc: 'Explore pokies, live dealer tables, fishing games, arcade games, and sports betting, with new releases added regularly from 8 top providers including BNG, JILI, VPOWER, MEGA888, JOKER, PEGASUS, WF GAMING, and CQ9 GAMING.' },
  { icon: 'ri-wallet-line', title: 'Secure & Fast Payments', desc: 'Instant deposits and efficient withdrawals through AU-friendly payment solutions: PayID, OSKO, Google Pay, Apple Pay, Visa, Mastercard, Amopay, SpeedPay. Amopay supports cryptocurrency deposits and withdrawals. Min deposit AUD 10. Our bank account for deposit are always changing. Always check before depositing.' },
];

export default function ProvidersAndFAQ() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <>
      {/* Why Choose */}
      <section className="relative py-14 sm:py-16 md:py-20 px-4 sm:px-5 md:px-8 overflow-hidden" style={{ background: '#0d1117' }}>
        <div className="section-divider absolute top-0 left-0 w-full"></div>
        <div className="relative max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <div className="badge-blue mb-5"><i className="ri-star-line"></i> Why Choose Bybid9</div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-3 px-1">Australia&apos;s Next Generation Online Casino</h2>
            <p className="text-[#56626B] text-base max-w-xl mx-auto">Built for players who want fast payouts, fair games, and generous rewards.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {WHY_FEATURES.map((f) => (
              <div key={f.title} className="group glass-card rounded-2xl p-6 flex flex-col gap-4 card-hover-glow">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl" style={{ background: 'rgba(71,202,241,0.1)', border: '1px solid rgba(71,202,241,0.2)' }}>
                  <i className={`${f.icon} text-[#47CAF1] text-xl`}></i>
                </div>
                <h3 className="text-white font-bold text-base">{f.title}</h3>
                <p className="text-[#56626B] text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom content + FAQ */}
      <section className="relative py-14 sm:py-16 md:py-20 px-4 sm:px-5 md:px-8 overflow-hidden" style={{ background: '#0d1117' }}>
        <div className="section-divider absolute top-0 left-0 w-full"></div>
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 80% 50%, rgba(71,202,241,0.04) 0%, transparent 60%)' }}></div>
        <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Left */}
          <div className="space-y-8 text-[#56626B] text-sm leading-relaxed">
            <div>
              <h2 className="text-2xl font-black text-white mb-3">Bybid9 | Australia&apos;s Best Online Entertainment &amp; Real Money Casino 2026</h2>
              <div className="glow-line w-20 mb-4"></div>
              <p>
                <strong className="text-white">Bybid9</strong> is an Australia-focused online pokies casino built for players seeking premium real money pokies, immersive live casino experiences, and high-performance mobile pokies. Play at Bybid9, a legit Australian casino with fast payouts. Exclusive Monthly Deposit Ranking AUD 3,999, Daily Easy Step AUD 100, min deposit AUD 10.
              </p>
              <p className="mt-3">
                Access a diverse portfolio of high RTP slots, trending Aussie style pokies, monthly leaderboard prizes, and classic table games, all optimised for seamless desktop and smartphone gameplay. Download the Bybid9 AUS App for the best play experience.
              </p>
              <p className="mt-3">
                <strong className="text-[#f87171]">IMPORTANT:</strong> Our bank account for deposit are always changing. Always make sure to check the available bank account before depositing. Transactions with sensitive word remarks on bank slips are strictly prohibited and may lead your bank account getting banned.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-white mb-2">Security &amp; Certifications</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                {SECURITY_CERTS.map((c) => (
                  <div key={c.title} className="glass-card rounded-xl px-3 sm:px-4 py-3 flex items-center gap-3 min-w-0">
                    <i className="ri-shield-check-line text-[#47CAF1] text-base flex-shrink-0"></i>
                    <div>
                      <p className="text-white font-bold text-xs">{c.title}</p>
                      <p className="text-[#56626B] text-xs">{c.sub}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl p-5" style={{ background: 'rgba(71,202,241,0.04)', border: '1px solid rgba(71,202,241,0.12)' }}>
              <div className="flex items-start gap-3">
                <i className="ri-shield-keyhole-line text-[#47CAF1] text-xl flex-shrink-0 mt-0.5"></i>
                <div>
                  <h4 className="text-white font-bold text-sm mb-1">Responsible Gambling</h4>
                  <p className="text-[#56626B] text-xs leading-relaxed">
                    Gamble responsibly. 18+ only. If gaming impacts your wellbeing, contact{' '}
                    <a href="https://www.gamblinghelponline.org.au/" target="_blank" rel="noreferrer" className="text-[#47CAF1] underline">Gambling Help Online</a>{' '}
                    or call the National Gambling Helpline on <strong className="text-white">1800 858 858</strong>.
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-2">
              <RegisterLink section="providers_faq" linkLabel="Create Free Account" href="https://bybid9.tips/RFLANDINGPAGESEO" className="btn-premium text-sm px-8 py-3"><span>Create Free Account</span></RegisterLink>
            </div>
          </div>

          {/* Right: FAQ */}
          <div>
            <div className="mb-8">
              <h2 className="text-2xl font-black text-white mb-3">Frequently Asked Questions</h2>
              <div className="glow-line w-20 mb-4"></div>
              <p className="text-[#56626B] text-sm">Everything you need to know about Bybid9.</p>
            </div>
            <div className="flex flex-col gap-3">
              {FAQS.map((faq, i) => (
                <div key={i} className={`faq-item ${openFaq === i ? 'open' : ''}`}>
                  <button
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer group"
                  >
                    <span className={`text-sm font-semibold transition-colors text-left pr-2 flex-1 min-w-0 ${openFaq === i ? 'text-[#47CAF1]' : 'text-white group-hover:text-[#47CAF1]'}`}>{faq.q}</span>
                    <div
                      className="w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 ml-4 transition-all duration-300"
                      style={openFaq === i
                        ? { background: 'rgba(71,202,241,0.2)', border: '1px solid rgba(71,202,241,0.4)', transform: 'rotate(45deg)' }
                        : { background: 'rgba(71,202,241,0.06)', border: '1px solid rgba(71,202,241,0.12)' }
                      }
                    >
                      <i className={`ri-add-line text-sm ${openFaq === i ? 'text-[#47CAF1]' : 'text-[#56626B]'}`}></i>
                    </div>
                  </button>
                  {openFaq === i && (
                    <div className="px-5 pb-4">
                      <p className="text-[#56626B] text-sm leading-relaxed">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
